
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.656 3c-.828 0-1.219.438-1.687.875-.469.438-.918.98-1.344 1.594-.129.183-.254.37-.375.562a8.874 8.874 0 00-.594-1.218c-.68-1.141-1.437-1.75-1.437-1.75l-1.25 1.562s.449.348.968 1.219C6.457 6.714 7 8.054 7 10v13h2V10c0-.184-.023-.355-.031-.531H9c0-.469.535-1.84 1.25-2.875.36-.52.742-.985 1.063-1.282.117-.109.226-.171.312-.218.078.047.18.11.281.218.293.32.645.829.969 1.375.324.547.605 1.168.813 1.688.207.52.312.984.312 1.094V23h2V9.469c0-.528.488-1.875 1.125-2.906.32-.516.652-.993.938-1.282.09-.093.175-.144.25-.187.09.05.21.117.343.25.324.328.7.855 1.063 1.406.363.55.707 1.137.937 1.656.23.52.344.992.344 1.063v10.25c0 2.418 1.402 4.633 2.719 6.281.293.367.597.691.875 1H22v2h6v-6h-2v2.594a19.37 19.37 0 01-.719-.844C24.098 23.266 23 21.3 23 19.719V9.469c0-.664-.21-1.23-.5-1.875a14.3 14.3 0 00-1.094-1.969 11.432 11.432 0 00-1.343-1.688c-.461-.467-.83-.937-1.72-.937-.827 0-1.245.43-1.687.875a9.28 9.28 0 00-1.25 1.625c-.164.27-.32.531-.469.813-.113-.208-.222-.422-.343-.625-.375-.637-.785-1.243-1.219-1.72-.434-.476-.828-.968-1.719-.968z"}})])
          )
        }
      }
    